module.exports = __webpack_public_path__ + "static/media/firebase.70498685.svg";